import { IMAGES, LINKS } from './site'

export type ServiceKey = 'auto' | 'commercial' | 'residential' | 'shower'

export interface Service {
  key: ServiceKey
  title: string
  heading: string
  description: string
  bullets: string[]
  detail: string
  image: string
  imageAlt: string
  href: string
  linkLabel: string
}

export const services: Service[] = [
  {
    key: 'auto',
    title: 'Auto Glass',
    heading: 'Auto Glass Repair & Windshield Replacement',
    description:
      'From a stone chip to a shattered window, get the right repair for your vehicle. Our certified technicians service cars, trucks, vans, fleets and semis throughout Southeast Michigan.',
    bullets: [
      'Windshield chip repair and replacement',
      'Side, door and rear window glass',
      'On-site ADAS calibration when your vehicle requires it',
    ],
    detail:
      'We help coordinate most insurance claims, and auto glass installation includes a lifetime vehicle-glass workmanship warranty.',
    image: IMAGES.auto,
    imageAlt: 'Technician inspecting a vehicle windshield',
    href: LINKS.auto,
    linkLabel: 'Explore Auto Glass Services',
  },
  {
    key: 'commercial',
    title: 'Commercial Glass',
    heading: 'Commercial Glass & Storefronts',
    description:
      'From a damaged storefront pane to a new commercial build, we repair, replace and install glass for businesses, builders and property managers.',
    bullets: [
      'Storefront windows, door glass and entry systems',
      'Office glass walls, partitions and dividers',
      'Curtain walls and glazing for new builds and renovations',
    ],
    detail:
      'Bring your plans, dimensions or photos. Our team can review the scope, fabrication, installation and bid requirements for your project.',
    image: IMAGES.commercial,
    imageAlt:
      'AI-generated concept of a modern Old Navy storefront with large glass panels and slim metal framing',
    href: LINKS.commercial,
    linkLabel: 'Explore Commercial Glass',
  },
  {
    key: 'residential',
    title: 'Residential Glass',
    heading: 'Residential Glass Repair & Replacement',
    description:
      'Broken pane or fog between the glass? If your window frames are still in good condition, replacing the glass or insulated unit may be all you need.',
    bullets: [
      'Broken windows and foggy double-pane glass',
      'Entry, patio and storm door glass',
      'Custom mirrors, tabletops, shelves and screens',
    ],
    detail:
      'We inspect the glass and existing frame, explain the options and provide free in-home estimates for your project.',
    image: IMAGES.residential,
    imageAlt: 'Home exterior with large windows',
    href: LINKS.residential,
    linkLabel: 'Explore Residential Glass',
  },
  {
    key: 'shower',
    title: 'Glass Shower Doors',
    heading: 'Custom Glass Shower Doors',
    description:
      'Finish your bathroom with shower glass made for the opening. We measure, fabricate and install enclosures to fit your tile and bathroom layout.',
    bullets: [
      'Frameless, Euro, semi-frameless and framed designs',
      'Sliding shower doors and tub enclosures',
      'Clear or textured glass with your choice of hardware',
    ],
    detail:
      'Our team helps you choose the glass style and hardware, then confirms the measurements before fabrication and installation.',
    image: IMAGES.shower,
    imageAlt: 'Custom glass shower enclosure in a tiled bathroom',
    href: LINKS.shower,
    linkLabel: 'Explore Glass Shower Doors',
  },
]
